import { DelayedLoadingIndicator } from '@numbox/components';

import { pureWithStyle } from '~/styles';

type Props = {
  classes: Readonly<Record<string, string>>;
};

/**
 * A spinner that appears in the center of its container.
 */
export default pureWithStyle<Props, React.ComponentType<Props>>(
  'CenteredSpinner',
  {
    root: {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  ({ classes }: Props) => {
    return (
      <div className={classes.root}>
        <DelayedLoadingIndicator />
      </div>
    );
  },
);
